import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface SubmoduleClassPractice {
  id: number;
  classes: number;
  description: string | null;
  status: number;
  practice_type: number;
  time_active_days: string;
  time_end_days: string;
  max_exam: number;
  time_value: number;
  exam_pass_score: number;
  created_date: string;
  updated_date: string;
}

export interface SubModuleItem {
  id: number;
  module: number;
  parent: number | null;
  name: string;
  description: string;
  sub_module_type: number;
  status: number;
  created_date: string;      // ISO datetime string
  updated_date: string;      // ISO datetime string
  question_in_exams: number;
  img_url: string | null;
  practice_type: number;
  active_class_submodules: boolean;
  submodule_class_practice?: SubmoduleClassPractice | null;
  question_count: number;
}
interface ModuleState {
  moduleAvailableList: any[];
  loading: boolean;
  loadingModuleDetail: boolean;
  moduleDetail: any;
  subModuleTree: any[];
  loadingSubModuleTree: boolean;
  subModuleV2: SubModuleItem[];
  subModuleDetail: any;
  loadingSubModuleDetail: boolean;
  edxQuestionByModule: any;
  isActiveFolder: boolean;
  edxListCourse: any[];
  syncSuccess: boolean;
  loadingEdxListCourse: boolean;
  activeSubModuleClassPractice: any[];
  loadingActiveSubModuleClassPractice: boolean;
  successActiveSubModuleClassPractice:boolean;
  resultsActiveSubModuleClassPractice:any
  gradeModuleList: any[];
  loadingAddModuleGrade: number;
  loadingDeleteModule: boolean;
  deleteModuleSuccess: boolean;
}
const initialState: ModuleState = {
  moduleAvailableList: [],
  loading: false,
  loadingModuleDetail: false,
  moduleDetail: {},
  subModuleTree: [],
  loadingSubModuleTree: false,
  subModuleV2: [],
  subModuleDetail: {},
  loadingSubModuleDetail: false,
  edxQuestionByModule: {},
  isActiveFolder: false,
  edxListCourse: [],
  syncSuccess: true,
  loadingEdxListCourse: false,
  activeSubModuleClassPractice: [],
  loadingActiveSubModuleClassPractice: false,
  successActiveSubModuleClassPractice: null,
  resultsActiveSubModuleClassPractice: {},
  gradeModuleList : [],
  loadingAddModuleGrade: 0,
  loadingDeleteModule: false,
  deleteModuleSuccess: false,
};

const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {
    setModuleAvailableList(state, action) {
      state.moduleAvailableList = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setModuleDetail(state, action) {
      state.moduleDetail = action.payload
    },
    setSubModuleTree(state, action) {
      state.subModuleTree = action.payload
    },
    setLoadingSubModuleTree(state, action: PayloadAction<boolean>) {
      state.loadingSubModuleTree = action.payload
    },
    setSubModuleV2(state, action) {
      state.subModuleV2 = action.payload
    },
    setSubModuleDetail(state, action) {
      state.subModuleDetail = action.payload
    },
    setLoadingSubModuleDetail(state, action) {
      state.loadingSubModuleDetail = action.payload
    },
    setEdxQuestionByModule(state, action) {
      state.edxQuestionByModule = action.payload
    },
    setIsActiveFolder(state, action) {
      state.isActiveFolder = action.payload
    },
    setEdxListCourse(state, action) {
      state.edxListCourse = action.payload
    },
    setSyncSuccess(state, action) {
      state.syncSuccess = action.payload
    },
    setLoadingEdxListCourse(state, action) {
      state.loadingEdxListCourse = action.payload
    },
    setActiveSubModuleClassPractice(state, action) {
      state.activeSubModuleClassPractice = action.payload
    },
    setLoadingActiveSubModuleClassPractice(state, action) {
      state.loadingActiveSubModuleClassPractice = action.payload
    },
    setSuccessActiveSubModuleClassPractice(state, action) {
      state.successActiveSubModuleClassPractice = action.payload
    },
    setResultsActiveSubModuleClassPractice(state, action) {
      state.resultsActiveSubModuleClassPractice = action.payload
    },
    setLoadingModuleDetail(state, action) {
      state.loadingModuleDetail = action.payload
    },
    setGradeModuleList(state, action) {
      state.gradeModuleList = action.payload;
    },
    setLoadingAddModuleGrade(state, action) {
      state.loadingAddModuleGrade = action.payload
    },
    setLoadingDeleteModule(state, action: PayloadAction<boolean>) {
      state.loadingDeleteModule = action.payload;
    },
    setDeleteModuleSuccess(state, action: PayloadAction<boolean>) {
      state.deleteModuleSuccess = action.payload;
    },
    resetModuleData(state) {
      state.moduleAvailableList = initialState.moduleAvailableList,
        state.loading = initialState.loading,
        state.moduleDetail = initialState.moduleDetail,
        state.subModuleTree = initialState.subModuleTree,
        state.loadingSubModuleTree = initialState.loadingSubModuleTree,
        state.subModuleDetail = initialState.subModuleDetail,
        state.loadingSubModuleDetail = initialState.loadingSubModuleDetail,
        state.edxQuestionByModule = initialState.edxQuestionByModule,
        state.isActiveFolder = initialState.isActiveFolder,
        state.edxListCourse = initialState.edxListCourse,
        state.syncSuccess = initialState.syncSuccess,
        state.loadingEdxListCourse = initialState.loadingEdxListCourse,
        state.activeSubModuleClassPractice = initialState.activeSubModuleClassPractice,
        state.loadingActiveSubModuleClassPractice = initialState.loadingActiveSubModuleClassPractice,
        state.loadingModuleDetail = initialState.loadingModuleDetail,
        state.loadingAddModuleGrade = initialState.loadingAddModuleGrade,
        state.loadingDeleteModule = initialState.loadingDeleteModule
    }
  }
})

export const {
  setModuleAvailableList,
  setLoading,
  setModuleDetail,
  setSubModuleTree,
  setLoadingSubModuleTree,
  setSubModuleDetail,
  setLoadingSubModuleDetail,
  setEdxQuestionByModule,
  setIsActiveFolder,
  resetModuleData,
  setEdxListCourse,
  setSyncSuccess,
  setLoadingEdxListCourse,
  setActiveSubModuleClassPractice,
  setLoadingActiveSubModuleClassPractice,
  setLoadingModuleDetail,
  setGradeModuleList,
  setLoadingAddModuleGrade,
  setLoadingDeleteModule,
  setDeleteModuleSuccess,
  setSubModuleV2,
  setSuccessActiveSubModuleClassPractice,
  setResultsActiveSubModuleClassPractice
} = moduleSlice.actions;

export default moduleSlice.reducer;
